<div class="holdout-settings-flyout">
  <div class="holdout-settings-header">
    <h2 class="holdout-settings-title">
      {{ "settings.account.holdout-group.title" | translate }}
      <mat-icon class="admin-only-icon">font_download</mat-icon>
    </h2>
    <button class="holdout-settings-close" type="button" (click)="closeFlyout()" [attr.aria-label]="'generic.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="holdout-settings-body">
    <p class="holdout-settings-description">
      {{ "settings.account.holdout-group.description" | translate }}
    </p>

    <div class="holdout-settings-row">
      <mat-slide-toggle color="primary" [checked]="enabled()" (change)="toggleEnabled($event.checked)">
        {{ "settings.account.holdout-group.title" | translate }}
      </mat-slide-toggle>
    </div>

    <div class="holdout-settings-row holdout-settings-row--percentage" [class.holdout-settings-row--disabled]="!enabled()">
      <span>{{ "settings.account.holdout-group.label-before" | translate }}</span>
      <mat-form-field class="holdout-settings-input" appearance="outline" floatLabel="auto">
        <input matInput type="number" [step]="1" [min]="1" [max]="50" [disabled]="!enabled()" [value]="percentage()" (input)="onPercentageInput($event)" />
      </mat-form-field>
      <span>{{ "settings.account.holdout-group.label-after" | translate }}</span>
    </div>

    <p class="holdout-settings-input-description">
      {{ "settings.account.holdout-group.input-description" | translate }}
    </p>

    @if (errorKey()) {
      <p class="holdout-settings-error">{{ errorKey() | translate }}</p>
    }
  </div>

  <div class="holdout-settings-footer">
    <button class="secondary-button" mat-stroked-button type="button" (click)="closeFlyout()" [disabled]="saving()">
      {{ "generic.cancel" | translate }}
    </button>
    <button class="primary-button" mat-stroked-button type="button" (click)="save()" [disabled]="saving()">
      {{ "generic.save" | translate }}
    </button>
  </div>
</div>
